import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import type { AfterViewInit, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-mega-trade-container',
  templateUrl: './mega-trade-container.html',
  styleUrls: ['./mega-trade-container.scss'],
})
export class MegaTradeContainerComponent implements OnInit, AfterViewInit {
  public steps: Array<object>;
  public currentStep = '/mega-trade/enter-details';
  public ignoreRoute: boolean;

  private router = inject(Router);

  ngOnInit() {
    this.buildProgressBar();
  }

  ngAfterViewInit() {
    this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationEnd &&
        this.router.url === 'mega-trade/enter-details/confirmation'
      ) {
        this.ignoreRoute = true;
      }
    });
  }

  private buildProgressBar(): void {
    this.steps = [
      {
        title: 'Enter Pool Details',
        url: '/mega-trade/enter-details',
      },
      {
        title: 'Review Pool Details',
        url: '/mega-trade/enter-details/review-and-commit',
      },
      {
        title: 'Confirmation',
        url: '/mega-trade/enter-details/confirmation',
      },
    ];
  }
}
